
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRank3 as ObiRank3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-rank-3.js';
 
 
 

 
 export const ObiRank3 = createComponent({
   react: React,
   tagName: 'obi-rank-3',
   elementClass: ObiRank3Element,
   events: {
     
   }
  });
 
 